module.exports = {"441302001":"桥东街道","441302002":"桥西街道","441302003":"江南街道","441302004":"江北街道","441302005":"龙丰街道","441302006":"河南岸街道","441302007":"惠环街道","441302008":"陈江街道","441302009":"水口街道","441302010":"小金口街道","441302100":"汝湖镇","441302103":"三栋镇","441302106":"潼湖镇","441302107":"沥林镇","441302109":"马安镇","441302110":"横沥镇","441302112":"芦洲镇","441302114":"潼侨镇","441302401":"东江高新科技产业园","441302402":"惠南高新科技产业园","441302450":"惠州市林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441302.json
// module id = 1845
// module chunks = 0